module.exports = __webpack_public_path__ + "static/media/arrow23.3c4d46d8.svg";